/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export function pickFooter(footerTheme) {
  switch (footerTheme) {
    case "footer_3":
      return import(
        /* webpackChunkName: "footer_3" */ "./components/rows/footer/footer-template-three/footer-template-three"
      );
    case "footer_2":
      return import(
        /* webpackChunkName: "footer_2" */ "./components/rows/footer/footer-template-two/footer-template-two"
      );
    case "footer_1":
      return import(
        /* webpackChunkName: "footer_1" */ "./components/rows/footer/footer-template-one/footer-template-one"
      );
    default:
      return import(
        /* webpackChunkName: "footer_1" */ "./components/rows/footer/footer-template-one/footer-template-one"
      );
  }
}
